import React from 'react';
import PanelHeader from '../PanelHeader';
import { useEditor } from '../EditorContext';
import { setBackgroundColor } from '../../canvasEditor';

export default function BasicsPanel() {
  const { bgColor, setBgColor, fabricRef } = useEditor();

  const onChange = (e) => {
    const color = e.target.value;
    setBgColor(color);
    const fc = fabricRef.current;
    if (fc) setBackgroundColor(fc, color);
  };

  return (
    <div className="pixie-panel">
      <PanelHeader title="Color" icon="fa-fill-drip" />
      <div className="pixie-color-area">
        <input
          type="color"
          value={bgColor}
          onChange={onChange}
          className="pixie-color-input"
          aria-label="Canvas background color"
        />
      </div>
    </div>
  );
}
